import { Box } from '@mui/material';

const statusStyles = {
  paid: {
    bg: '#D1FAE5',
    color: '#065F46',
    label: 'Оплачено',
  },
  unpaid: {
    bg: '#FEF3C7',
    color: '#92400E',
    label: 'Не оплачено',
  },
};

// `md` mirrors the metrics of the score badge in LessonScoreCell (12/6 padding,
// 8px radius, 14px text over a 1px border) so the two sit as equals in the
// narrow-screen card row. The transparent border is purely geometry.
const sizeStyles = {
  sm: { px: 1.5, py: 0.4, fontSize: 12 },
  md: { px: 1.5, py: 0.75, fontSize: 14, lineHeight: 1.43, border: '1px solid transparent' },
};

const PaymentBadge = ({ paid, onToggle, disabled, size = 'sm' }) => {
  const state = paid ? statusStyles.paid : statusStyles.unpaid;

  return (
    <Box
      role={!disabled && onToggle ? 'button' : undefined}
      onClick={disabled ? undefined : onToggle}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: 2,
        fontWeight: 600,
        ...(sizeStyles[size] || sizeStyles.sm),
        color: state.color,
        bgcolor: state.bg,
        cursor: onToggle && !disabled ? 'pointer' : 'default',
        transition: 'all 0.15s ease',
        '&:hover': onToggle && !disabled ? { opacity: 0.85 } : undefined,
        userSelect: 'none',
      }}
    >
      {state.label}
    </Box>
  );
};

export default PaymentBadge;
